import React, { Component } from "react"
import PropTypes from "prop-types"
import SbEditable from "storyblok-react"

import { resizeWithFocusPoint } from "../../helpers/image"
import "../image/image.scss"

class ImageFocusPoint extends Component {
  componentDidMount() {
    if (this.element) {
      const { blok } = this.props
      this.element.src = blok.image
    }
  }

  render() {
    const { blok, className } = this.props

    return (
      <SbEditable content={blok}>
        <img
          data-src={
            resizeWithFocusPoint(
              blok.image.image,
              blok.image.imageSize,
              blok.image.focusPoint,
              {
                width: 600,
                height: 300,
              }
            ).url
          }
          className={`lazyload ${className}`}
          alt={blok.alt}
          title={blok.title}
        />
      </SbEditable>
    )
  }
}

ImageFocusPoint.defaultProps = {
  className: "image",
}

ImageFocusPoint.propTypes = {
  blok: PropTypes.shape({
    image: PropTypes.shape({
      image: PropTypes.string,
    }),
  }).isRequired,
  className: PropTypes.string,
}

export default ImageFocusPoint
